<template>
  <div>
    <form @submit.stop.prevent="form.handleSubmit()">
      <form.Field
        name="fromAddress"
        :validators="{
          onBlur: yup.string().email('Invalid email address').required('Email is required')
        }"
      >
        <template #default="{ field }">
          <BaseInput
            :model-value="(field.state.value as string)"
            :name="field.name"
            label="Default From Address:"
            placeholder="Email from address"
            :error="(field.state.meta.errors && field.state.meta.errors[0] as string)"
            @blur="field.handleBlur"
            @input="(e) => field.handleChange(e.target.value)"
          />
        </template>
      </form.Field>

      <form.Subscribe>
        <template #default="{ canSubmit, isSubmitting }">
          <BaseButton
            variant="primary"
            type="submit"
            :disabled="!canSubmit || isSubmitting"
            :class="{ 'cursor-not-allowed opacity-50': !canSubmit || isSubmitting }"
          >
            <div class="flex justify-between items-center gap-2">
              <span>Save</span>
              <span
                v-if="isSubmitting"
                class="i-heroicons-arrow-path animate-spin"
              />
            </div>
          </BaseButton>
        </template>
      </form.Subscribe>
    </form>
  </div>
</template>

<script lang="ts" setup>
import BaseInput from '@/components/base/BaseInput.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useForm } from '@tanstack/vue-form'
import { yupValidator } from '@tanstack/yup-form-adapter'
import * as yup from 'yup'
import { useMutation } from '@tanstack/vue-query'
import { useNotification } from '@kyvg/vue3-notification'
import SettingService from '@/services/SettingService'

const props = defineProps({
  model: {
    type: String,
    required: true
  }
})

const form = useForm({
  defaultValues: {
    fromAddress: props.model
  },
  validatorAdapter: yupValidator(),
  onSubmit: async ({ value }) => {
    console.log(value.fromAddress)
    await updateEmailAddress(value.fromAddress)
  }
})

const emailService = new SettingService()
const { notify } = useNotification()

const { mutateAsync: updateEmailAddress } = useMutation({
  mutationFn: async (email: string) =>  emailService.update('emailDefaultFromAddress' , { value: email }),
  onSuccess: () => {
    notify({
      title: 'Success',
      text: 'Email address updated successfully.',
      type: 'success'
    })
  },
  onError: (error) => {
    notify({
      type: 'error',
      title: 'Error',
      text: error.message || 'An error occurred while trying to update the email address.'
    })
  }
})

</script>
